import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Avatar,
  TextField,
  InputAdornment,
  MenuItem,
  Button,
  Stack,
  Toolbar,
  IconButton,
  Tooltip
} from '@mui/material';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import downloadFill from '@iconify/icons-eva/download-fill';
import calendarFill from '@iconify/icons-eva/calendar-fill';
import { useFetchOnDemand } from 'src/hooks/useFetch.hook';
import { commandsHistoryColumns } from '../../constants/ocpi.constant';
import { BaseTable } from 'src/components/BaseTable/BaseTable';
import { useDropdown } from 'src/hooks/useDropdown.hook';
import { debounceFunc } from 'src/utils/helper';

export default function HistoryTab({ data }) {
 // const historyData = data?.commandHistory || [];
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('All Status');
  const [typeFilter, setTypeFilter] = useState('All Types');
  const [partnerFilter, setPartnerFilter] = useState('All Partners');
  const { data: ocpiPartners } = useDropdown("ocpi_partners");
  const { data: commandStatus } = useDropdown("command_status");
  const { data: commandType } = useDropdown("command_type");
  const { data: historyData, isLoading, mutate: fetchHistoryData } = useFetchOnDemand("commandsHistory");
  // Function to fetch history data with current filter criteria
  const loadHistoryData = () => {
    const params = {
      limit: 50,
      offset: 0,
      partner_id: 'all',
      status: 'All Status',
      type: 'All Types'
    };

    // Add search parameter if search term exists
    if (searchTerm.trim()) {
      params.search = searchTerm.trim();
    }

    // Add status filter if not 'All Status'
    if (statusFilter !== 'All Status') {
      params.status = statusFilter;
    }

    // Add type filter if not 'All Types'
    if (typeFilter !== 'All Types') {
      params.type = typeFilter;
    }

    if (partnerFilter !== 'All Partners') {
      params.partner_id = partnerFilter;
    }

    fetchHistoryData(params);
  };

  // Load data on component mount and when filters change
  React.useEffect(() => {
    loadHistoryData();
  }, [searchTerm, statusFilter, typeFilter, partnerFilter]);

  return (
    <Box sx={{ p: 3 }}>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Command History
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Historical record of all OCPI commands
          </Typography>

          {/* Search and Filter Toolbar */}
          <Toolbar sx={{ px: 0, mb: 2 }}>
            <TextField
              placeholder="Search commands..."
              size='small'
              onChange={(e) => 
                debounceFunc(() => {
                  setSearchTerm(e.target.value);
                }, 800)()
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Icon icon={searchFill} width={20} height={20} />
                  </InputAdornment>
                ),
              }}
              sx={{ minWidth: 300, mr: 2 }}
            />
            
            <TextField
              select
              size='small'
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              sx={{ minWidth: 150, mr: 2 }}
            >
              {commandStatus?.map((status) => (
                <MenuItem key={status.id} value={status.value}>
                  {status.label}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              select
              size='small'
              value={typeFilter}
              onChange={(e) => setTypeFilter(e.target.value)}
              sx={{ minWidth: 150, mr: 2 }}
            >
              {commandType?.map((type) => (
                <MenuItem key={type.id} value={type.value}>
                  {type.label}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              select
              size='small'
              value={partnerFilter}
              onChange={(e) => setPartnerFilter(e.target.value)}
              sx={{ minWidth: 150, mr: 2 }}
            >
              <MenuItem value="All Partners">All Partners</MenuItem>
              {ocpiPartners?.map((partner) => (
                <MenuItem key={partner.id} value={partner.id}>
                  {partner.label}
                </MenuItem>
              ))}
            </TextField>

            <Box sx={{ flexGrow: 1 }} />
{/*             
            <Stack direction="row" spacing={1}>
              <Tooltip title="Date Range">
                <IconButton size='small'>
                  <Icon icon={calendarFill} width={20} height={20} />
                </IconButton>
              </Tooltip>
            </Stack> */}
          </Toolbar>

          {/* History Table using BaseTable */}
          <BaseTable
            rows={historyData || []}
            columns={commandsHistoryColumns}
            getRowId={(row) => row.id}
            loading={isLoading}
            showExportCsvBtn={true}
            pageSize={50}
            rowsPerPageOptions={[50, 100, 200]}
            pagination={true}
            paginationModel={{ page: 0, pageSize: 50 }}
            // onPageChange={(page) => {
            //   setPaginationModel({ ...paginationModel, page });
            // }}
          />
        </CardContent>
      </Card>
    </Box>
  );
}
